import Mapboard from '../../components/maps';

export default Mapboard;